(function() {
    async function fetchAllProducts() {
        let products = [];
        let lastId = 1;
        let hasMoreProducts = true;
        while (hasMoreProducts) {
            const response = await fetch('/collections/all/products.json?limit=250&page=' + lastId);
            const data = await response.json();
            if (data.products.length == 250) {
                products = products.concat(data.products);
                lastId = lastId + 1;
            } else {
                hasMoreProducts = false;
                products = products.concat(data.products);
            }
        }
        return products;
    }
    function getRemoteFileSync(doucjsoncols) {
        var xhr = new XMLHttpRequest();
        xhr.open("GET", doucjsoncols, false);
        xhr.send();
        if (xhr.status === 200) {
            return JSON.parse(xhr.responseText);
        } else {
            throw new Error(`Request failed with status ${xhr.status}`);
        }
    }
    document.querySelectorAll('.price-list sale-price, .price-list compare-at-price').forEach(function(priceElement) {
        priceElement.innerHTML = priceElement.innerHTML.replace(',00', '');
    });
    const findthevariantscolor = function() {
        const variants = [];
        let variant = {};
        const doucjsoncols = document.getElementsByClassName("jsonassets").length > 0 ? document.getElementsByClassName("jsonassets")[0].innerHTML != "" ? document.getElementsByClassName("jsonassets")[0].innerHTML : "" : ""
        let doucalscolors = {};
        function getRemoteFileSync(doucjsoncols) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", doucjsoncols, false);
            xhr.send();
            if (xhr.status === 200) {
                return JSON.parse(xhr.responseText);
            } else {
                throw new Error(`Request failed with status ${xhr.status}`);
            }
        }
        let doucalslist = {};
        let doucalslistb = {};
        if (doucjsoncols.trim() != "") {
            try {
                doucalscolors = getRemoteFileSync(doucjsoncols);
                let itemsWithBlank = {};
                let itemsWithoutBlank = {};
                doucalscolors.forEach(item => {
                    const nomeColore = item["nome colore"];
                    const codiceColore = item["codice colore"];
                    const immagine = item["immagine"];
					//console.log("nomeColore "+nomeColore+" codiceColore:"+codiceColore+" immagine:"+immagine);
                    if (codiceColore) {
                        if (nomeColore.includes(" ")) {
                            itemsWithBlank[nomeColore.toLowerCase()] = codiceColore;
							itemsWithBlank[nomeColore.replace(/"/g, "").toLowerCase()] = codiceColore;
                        } else {
                            itemsWithoutBlank[nomeColore.toLowerCase()] = codiceColore;
							itemsWithoutBlank[nomeColore.replace(/"/g, "").toLowerCase()] = codiceColore;
                        }
                    }
                });
                doucalslistb['blank'] = itemsWithBlank;
                doucalslistb['noblank'] = itemsWithoutBlank;
                doucalslist = {
                    ...itemsWithBlank,
                    ...itemsWithoutBlank
                };
                //console.log(doucalslist);
            } catch (error) {
                console.error(error);
            }
        }
        const colorSwatches = document.querySelectorAll('.accordion__content .color-swatch');
        if (colorSwatches.length > 0) {
            colorSwatches.forEach(swatch => {
                let style = swatch.getAttribute('style').toLowerCase();
                Object.keys(doucalslistb).forEach(k => {
                    Object.keys(doucalslistb[k]).forEach(key => {
                        const item = doucalslistb[k][key];
//console.log("colore:"+item+" key "+key+" style"+style);
                        if ((item.indexOf("-") > 1) && (style.indexOf(key) > -1)) {
                            //console.log("contiene - colore:"+item);
                            let gradient = item.split("-");
                            style = style.replace(key, gradient[0])
                            style = style.replace(key, gradient[1])
                        } else {
                            style = style.replaceAll(key + " chiaro", item)
                            style = style.replaceAll(key + " scuro", item)
                            style = style.replaceAll(key, item)
                        }
                    });
                });
                swatch.setAttribute('style', style);
            });
        }
        fetchAllProducts().then(products => {
            if (typeof document.getElementById("dmodaartcode") !== 'undefined' && document.getElementById("dmodaartcode") !== null) {
                const dmodaartcode = document.getElementById("dmodaartcode").innerHTML;
                const maincolor = document.getElementById("maincolor").innerHTML;
                const productcode = document.getElementById("productcode").innerHTML.toLowerCase();
                const productid = document.getElementById("productid").innerHTML.toLowerCase();
                const lang = document.getElementsByClassName("storelang").length > 0 ? document.getElementsByClassName("storelang")[0].innerHTML != "" ? document.getElementsByClassName("storelang")[0].innerHTML + "/" : "" : ""

                products.forEach((product, index) => {
                    //if (product.id != productid) {
                    if (1) {
						
						
						
                        if (product.tags.join(" ").toLowerCase().indexOf("product_code|" + productcode) > -1) {
							//console.log(product.tags.join(" ").toLowerCase());
						//console.log("qui sopra cerco "+productcode);
						 
                            variant = {};
                            product.tags.forEach((tag, id) => {
                                tag = tag.split("|");
                                if ((tag[0] == "dmoda_art_code") || (tag[0] == "main_color") || (tag[0] == "color_code") || (tag[0] == "desc_colore")) {
                                    variant[tag[0]] = tag[1];
                                    if (typeof variant['handle'] === 'undefined') {
                                        variant['handle'] = product.handle;
                                        variant['title'] = product.title;
                                    }
                                }
                            });
                            variants.push(variant);
                        }
                    }
                });
                if (variants.length > 0) {
                   
                    let html = "";
                    let htmlnotselected = "";
                    // ready to build the variant color box
                    variants.forEach((variant, idx) => {
                        if (doucalslist[variant['desc_colore'].toLowerCase()] === undefined) {
                            doucalslist[variant['desc_colore'].toLowerCase()] = "#000";
                        }
						
						//console.log("# "+maincolor.toLowerCase()+" # "+variant['color_code'].toLowerCase());
						
                        if (maincolor.toLowerCase() == variant['color_code'].toLowerCase()) {
							//console.log(doucalslist[variant['desc_colore'].toLowerCase()]+" "+variant['desc_colore'].toLowerCase());
                            if(doucalslist[variant['desc_colore'].toLowerCase()].indexOf("-") > -1){
                               const blockc= doucalslist[variant['desc_colore'].toLowerCase()].split("-");
                               html = html + "<a  title='" + variant['desc_colore'] + "' class='douccolselected' style='--swatch-background: linear-gradient(to right, "+blockc[0]+",  "+blockc[1]+");background: content-box var(--swatch-background) no-repeat center / cover; "  + "'></a>";
                            }
                          else{
                            html = html + "<a  title='" + variant['desc_colore'] + "' class='douccolselected' style='background: " + doucalslist[variant['desc_colore'].toLowerCase()] + "'></a>";
                          }
                        } else {
                            htmlnotselected = htmlnotselected + "<a href='/" + lang + "products/" + variant['handle'] + "' title='" + variant['title'] + " " + variant['desc_colore'] + "' class='' style='background: " + doucalslist[variant['desc_colore'].toLowerCase()] + "'></a>";
                        }
                    });
                    const display_variants = document.getElementById('display_variants');
                    display_variants.innerHTML = html + htmlnotselected;
                }
            } else {
             
                /*
                let variants = [];
                let variant = {};
                const productslisting = document.querySelectorAll('.product-card .product-card__info .productcode');
                let currentcolor = "";
                let currentproduct = "";
                const lang = document.getElementsByClassName("storelang").length > 0 ? document.getElementsByClassName("storelang")[0].innerHTML != "" ? document.getElementsByClassName("storelang")[0].innerHTML + "/" : "" : ""
                productslisting.forEach(prod => {
                    let display_variants = "";
                    if ((prod.parentNode.getElementsByClassName("productid").length > 0)  && (prod.parentNode.getElementsByClassName("maincolor").length > 0)){
                        productid = prod.parentNode.getElementsByClassName("productid")[0].textContent;
                        maincolor = prod.parentNode.getElementsByClassName("maincolor")[0].textContent;
                        products.forEach((product, index) => {
                            display_variants = "";
                            if (1) {
                                if (product.tags.join(" ").toLowerCase().indexOf("product_code|" + prod.innerHTML.toLowerCase()) > -1) {
                                    variant = {};
                                    product.tags.forEach((tag, id) => {
                                        tag = tag.split("|");
                                        if ((tag[0] == "dmoda_art_code") || (tag[0] == "main_color") || (tag[0] == "color_code") || (tag[0] == "desc_colore")) {
                                            variant[tag[0]] = tag[1];
                                            if (typeof variant['handle'] === 'undefined') {
                                                variant['handle'] = product.handle;
                                                variant['title'] = product.title;
                                            }
                                        }
                                    });
                                    variants.push(variant);
                                }
                            }
                        });
                        if (variants.length > 0) {
                            let html = "";
                            let htmlnotselected = "";
                            // ready to build the variant color box
                            variants.forEach((variant, idx) => {
                                if (doucalslist[variant['desc_colore'].toLowerCase()] === undefined) {
                                    doucalslist[variant['desc_colore'].toLowerCase()] = "#000";
                                }
                                if (maincolor.toLowerCase() == variant['color_code'].toLowerCase()) {
                                    html = html + "<a  title='" + variant['desc_colore'] + "' class='douccolselected' style='background: " + doucalslist[variant['desc_colore'].toLowerCase()] + "'></a>";
                                } else {
                                    htmlnotselected = htmlnotselected + "<a href='/" + lang + "products/" + variant['handle'] + "' title='" + variant['title'] + " " + variant['desc_colore'] + "' class='' style='background: " + doucalslist[variant['desc_colore'].toLowerCase()] + "'></a>";
                                }
                            });
                            variants = [];
                            display_variants = prod.parentNode.getElementsByClassName('display_variants')[0];
                            display_variants.innerHTML = html + htmlnotselected;
                        }
                    }
					else{ productid = prod.parentNode.getElementsByClassName("productid")[0].textContent;
					console.log("product id "+productid+" mancante color fra i tags"); }
                });*/
            }
        });
    }
    findthevariantscolor();
    function countCheckedCheckboxes() {
        const checkboxes = document.querySelectorAll('.dot-checkbox');
        let count = 0;
        checkboxes.forEach(function(checkbox) {
            if (checkbox.checked) {
                count++;
            }
        });
        return count;
    }
    document.addEventListener('click', function(event) {
        if ((event.target.classList.contains('pagination__link')) || (event.target.classList.contains('w-full')) || (event.target.classList.contains('icon-close')) || (event.target.classList.contains('facets-clear-all')) || (event.target.classList.contains('link'))) {
            findthevariantscolor();
            const checkboxes = document.querySelectorAll('.dot-checkbox');
            checkboxes.forEach(function(checkbox) {
                checkbox.addEventListener('click', function() {
                    const cava = document.getElementById('facets-drawer-filter.v.availability').checked;
                    if (countCheckedCheckboxes() == 0) {
                        if (cava == true) {
                            document.getElementById('facets-drawer-filter.v.availability').click();
                        }
                    }
                    if (countCheckedCheckboxes() > 0) {
                        if (cava == false) {
                            document.getElementById('facets-drawer-filter.v.availability').click();
                        }
                    }
                });
            });
        }
    });
})();